module.exports = { str: "7.5.0" };



//////////////////
// WEBPACK FOOTER
// ./~/auth0-js/version.js
// module id = 497
// module chunks = 0